import React from 'react';
import './TosAcceptanceDialog.css';

// Current ToS version — must match CURRENT_TOS_VERSION in users/tos.py
// and the "Last updated" date on the /terms page.
export const CURRENT_TOS_VERSION = '2026-08-06';

const TosAcceptanceDialog = ({ onAccept, onDecline, error, submitting }) => {
  return (
    <div className="dialog-overlay">
      <div className="tos-acceptance-dialog" role="dialog" aria-modal="true" aria-labelledby="tos-acceptance-title">
        <h2 id="tos-acceptance-title">Terms of Service</h2>
        <div className="tos-acceptance-body">
          <p>
            Before you can use Tweedia Studio, please review and accept our
            Terms of Service and Privacy Policy.
          </p>
          <div className="tos-acceptance-details">
            <p><strong>By accepting, you agree to:</strong></p>
            <ul>
              <li>
                Our{' '}
                <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
                {' '}&mdash; the rules governing your use of Tweedia
              </li>
              <li>
                Our{' '}
                <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                {' '}&mdash; how we collect, use, and protect your data
              </li>
            </ul>
          </div>
          <p className="tos-acceptance-legal">
            You can review the full text of each document by clicking the links
            above. If you do not agree, you may decline and your account will be
            signed out.
          </p>
        </div>
        {error && (
          <p className="tos-acceptance-error" role="alert" data-testid="tos-accept-error">
            {error}
          </p>
        )}
        <div className="tos-acceptance-actions">
          <button className="btn-skip" onClick={onDecline} disabled={submitting}>Decline</button>
          <button
            className="btn btn-teal"
            onClick={onAccept}
            disabled={submitting}
            data-testid="tos-accept-btn"
          >
            {submitting ? 'Saving…' : 'I Accept'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TosAcceptanceDialog;
